/* eslint-disable */
import base64 from 'base-64';
import { get, post } from './request';
import { defaultPageSize } from '../constants';
const initalAuthorization =
  'Basic dGF4VHJhbnNwYXJlbmN5OipNaXJzV3RDcSVjckAhMQ==';

export async function login (authUrl, { username, password, office }) {
  try {
    const { body } = await post(
      `Basic ${base64.encode(`${username}:${password}`)}`,
      `${authUrl}/trueprodigy/auth/token`,
      { office }
    );
    return body;
  } catch (error) {
    /* eslint-disable no-throw-literal */
    if (error.body.httpStatus === 401) {
      throw 'incorrect';
    }
    throw error;
  }
}

export async function fetchToken (baseUrl, authenticationToken, office) {
  const url = `${baseUrl}/trueprodigy/taxtransparency/auth/token`;
  const { body } = await post(initalAuthorization, url, { office });
  return body;
}

export async function fetchClientConfig (baseUrl, authenticationToken) {
  const url = `${baseUrl}/taxtransparency/configuration`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSearchConfig (baseUrl, authenticationToken) {
  const url = `${baseUrl}/taxtransparency/config/propertysearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchSearchResultConfig (baseUrl, authenticationToken) {
  const url = `${baseUrl}/taxtransparency/config/propertysearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function search (
  baseUrl,
  authenticationToken,
  {
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    searchOptions
  }
) {
  let url = `${baseUrl}/taxtransparency/property/search`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  const { body } = await post(authenticationToken, url, searchOptions);
  return body;
}

export async function fetchCurrentYear (baseUrl, authenticationToken) {
  const url = `${baseUrl}/taxtransparency/currentyear`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchImportStatus (baseUrl, authenticationToken) {
  const url = `${baseUrl}/taxtransparency/importstatus`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchProperty (
  baseUrl,
  authenticationToken,
  { propertyId, ownerId }
) {
  const url = `${baseUrl}/taxtransparency/property/${propertyId}/${ownerId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function openHearing (baseUrl, authenticationToken, { id }) {
  const url = `${baseUrl}/taxingunit/hearings/${id}/notice`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray'
  });
  return body;
}

export async function fetchTaxingUnit (baseUrl, authenticationToken, { id }) {
  const url = `${baseUrl}/taxingunit/${id}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchETRPDF (baseUrl, authenticationToken, { id, year }) {
  const url = `${baseUrl}/taxingunit/${id}/taxrates/${year}/etrworksheetpdf`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray'
  });
  return body;
}

export async function fetchProposedPDF (baseUrl, authenticationToken, { id, year }) {
  const url = `${baseUrl}/taxingunit/${id}/taxrates/${year}/proposedpdf`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray'
  });
  return body;
}

export async function fetchVoterPDF (baseUrl, authenticationToken, { id, year }) {
  const url = `${baseUrl}/taxingunit/${id}/taxrates/${year}/voterapprovalpdf`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray'
  });
  return body;
}

export async function fetchAdoptedPDF (
  baseUrl,
  authenticationToken,
  { id, year }
) {
  const url = `${baseUrl}/taxingunit/${id}/taxrates/${year}/adoptionpdf`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray'
  });
  return body;
}

export async function fetchBudgetPDF (
  baseUrl,
  authenticationToken,
  { id, year }
) {
  const url = `${baseUrl}/taxingunit/${id}/taxrates/${year}/budgetinformationpdf`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray'
  });
  return body;
}

export async function fetchElectionPDF (
  baseUrl,
  authenticationToken,
  { id, year }
) {
  const url = `${baseUrl}/taxingunit/${id}/taxrates/${year}/mandatoryelectionpdf`;
  const { body } = await get(authenticationToken, url, {
    outputType: 'bytearray'
  });
  return body;
}

export async function fetchHistoricalRates (
  baseUrl,
  authenticationToken,
  { propertyID, taxingUnitID, ownerId }
) {
  const url = `${baseUrl}/taxtransparency/property/${propertyID}/${ownerId}/taxingunit/${taxingUnitID}/historicalrates`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createTaxingUnitMessage (
  baseUrl,
  authenticationToken,
  { id, year, message, isOwner, pID, contactPhone, contactEmail, questions, ownerID }
) {
  const url = `${baseUrl}/taxingunit/${id}/publicmessages/${year}`;
  const { body } = await post(authenticationToken, url, {
    publicMessage: message,
    isPropertyOwner: isOwner,
    pID,
    contactPhone,
    contactEmail,
    questions,
    ownerID
  });
  return body;
}

export const generateReport = async (
  baseUrl,
  authenticationToken,
  { payload, fileName },
) => {

  const url = `${baseUrl}/public/runreport`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('Content-Type', 'application/json');

  return await fetch(url, {
    method: 'PUT',
    headers,
    body: JSON.stringify(payload),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = `${fileName}.pdf`;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};
